import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { TranslationsProvider, Translations } from '@teliaee/telia-translate';
import Config from '../Config';
import JsxRenderer from '../content/JsxRenderer';
import LanguageStore, { Language } from '../stores/LanguageStore';
import { DEFAULT_APP } from '../util/TranslateUtil';

interface Props {
  children?: React.ReactChild | React.ReactChild[];
  languageStore?: LanguageStore;
  translations: Translations;
  initialLang: Language;
}

const TranslationsContextWrapper: React.FC<Props> = inject('languageStore')(
  observer((props: Props): JSX.Element => {
    const lang = props.languageStore.currentLanguage;
    const languageNotChanged = lang === props.initialLang;
    return (
      <TranslationsProvider
        translations={languageNotChanged ? props.translations : undefined}
        tier={Config.componentTier}
        lang={lang}
        defaultApp={DEFAULT_APP}
        labelsUrl={`${Config.apiUrl}/translations/${lang}`}
        disableStatistics={!Config.enableLabelStatistics}
        jsxRenderer={({ jsx }) => <JsxRenderer jsx={jsx} doNotScroll={true} renderInWrapper={false} />}
      >
        {props.children}
      </TranslationsProvider>
    );
  })
);

export default TranslationsContextWrapper;
